import planillasApi from "../Planillas/api";

const conValor = (valor) => String(valor || "").trim();

/**
 * GET /clientes
 * tipo: juridico | natural
 * Jurídico: numeroNit, razonSocial, email, celular (cualquiera, no todos)
 * Natural: identificacion, nombre, apellido, email, celular (cualquiera, no todos)
 */
export const consultarClientes = async (filtros = {}) => {
  const params = { tipo: filtros.tipo };

  [
    "numeroNit",
    "razonSocial",
    "identificacion",
    "nombre",
    "apellido",
    "email",
    "celular",
  ].forEach((campo) => {
    const valor = conValor(filtros[campo]);
    if (valor) params[campo] = valor;
  });

  const respuesta = await planillasApi.get("/clientes", { params });
  return respuesta.data;
};

export const actualizarCliente = async (id, datos) => {
  const respuesta = await planillasApi.patch(`/clientes/${id}`, datos);
  return respuesta.data;
};

export const consultarAuditoriaClientes = async (nit) => {
  const params = {};
  const valor = conValor(nit);
  if (valor) params.nit = valor;
  const respuesta = await planillasApi.get("/clientes/auditoria", { params });
  return respuesta.data;
};
